export interface Coordinate {
  latitude: number;
  longitude: number;
}

const PI = Math.PI;
const EARTH_RADIUS = 6378245.0;
const ECCENTRICITY = 0.00669342162296594323;

function isOutsideChina(latitude: number, longitude: number) {
  return longitude < 72.004 || longitude > 137.8347 || latitude < 0.8293 || latitude > 55.8271;
}

function transformLatitude(x: number, y: number) {
  let result = -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x));
  result += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0;
  result += (20.0 * Math.sin(y * PI) + 40.0 * Math.sin(y / 3.0 * PI)) * 2.0 / 3.0;
  result += (160.0 * Math.sin(y / 12.0 * PI) + 320 * Math.sin(y * PI / 30.0)) * 2.0 / 3.0;
  return result;
}

function transformLongitude(x: number, y: number) {
  let result = 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x));
  result += (20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0 / 3.0;
  result += (20.0 * Math.sin(x * PI) + 40.0 * Math.sin(x / 3.0 * PI)) * 2.0 / 3.0;
  result += (150.0 * Math.sin(x / 12.0 * PI) + 300.0 * Math.sin(x / 30.0 * PI)) * 2.0 / 3.0;
  return result;
}

export function wgs84ToGcj02(latitude: number, longitude: number): Coordinate {
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude) || isOutsideChina(latitude, longitude)) {
    return { latitude, longitude };
  }

  let deltaLatitude = transformLatitude(longitude - 105.0, latitude - 35.0);
  let deltaLongitude = transformLongitude(longitude - 105.0, latitude - 35.0);
  const radianLatitude = latitude / 180.0 * PI;
  let magic = Math.sin(radianLatitude);
  magic = 1 - ECCENTRICITY * magic * magic;
  const sqrtMagic = Math.sqrt(magic);
  deltaLatitude = (deltaLatitude * 180.0) / ((EARTH_RADIUS * (1 - ECCENTRICITY)) / (magic * sqrtMagic) * PI);
  deltaLongitude = (deltaLongitude * 180.0) / (EARTH_RADIUS / sqrtMagic * Math.cos(radianLatitude) * PI);
  return {
    latitude: latitude + deltaLatitude,
    longitude: longitude + deltaLongitude,
  };
}
